import { render, staticRenderFns } from "./NewHotel.vue?vue&type=template&id=3eb07b14&"
import script from "./NewHotel.vue?vue&type=script&lang=js&"
export * from "./NewHotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports